import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import type { DeploymentTopologyEnvironmentType } from '@wix/cli-astro-definitions';
import type { PreviewResult } from './Preview.js';
import { Preview } from './Preview.js';
import { useProjectModel } from '../../model.js';

export const PreviewCommand: FC<{
  environment: DeploymentTopologyEnvironmentType;
  baseUrl?: string;
  label?: string;
  previewId?: string;
  onPreviewCreated?: (result: PreviewResult) => void;
}> = ({ environment, baseUrl, label, previewId, onPreviewCreated }) => {
  const { model } = useProjectModel();

  return model.config.projectType === 'Site' ? (
    <SiteAuthProvider siteId={model.config.siteId}>
      <Preview
        baseUrl={baseUrl}
        previewId={previewId}
        onPreviewCreated={onPreviewCreated}
        environment={environment}
        label={label}
      />
    </SiteAuthProvider>
  ) : (
    <Preview
      baseUrl={baseUrl}
      previewId={previewId}
      onPreviewCreated={onPreviewCreated}
      environment={environment}
      label={label}
    />
  );
};
